// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"355":"7f79d4a1","523":"6b50e8ed","611":"1023bcab","658":"bdb7f0e9","980":"326e681d"}[chunkId] + ".css";
};